<template>
  <span :class="className">
    <svg :width="width" :height="height" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path :fill="fillColor"
        d="M7.89389 1.46089C8.3179 0.513036 9.6821 0.513036 10.1061 1.46089C10.6914 2.76935 12.2097 3.39825 13.5488 2.88691C14.5189 2.51649 15.4835 3.48113 15.1131 4.45118C14.6018 5.79028 15.2307 7.30858 16.5391 7.89389C17.487 8.3179 17.487 9.6821 16.5391 10.1061C15.2307 10.6914 14.6018 12.2097 15.1131 13.5488C15.4835 14.5189 14.5189 15.4835 13.5488 15.1131C12.2097 14.6018 10.6914 15.2307 10.1061 16.5391C9.6821 17.487 8.3179 17.487 7.89389 16.5391C7.30858 15.2307 5.79028 14.6018 4.45118 15.1131C3.48113 15.4835 2.51649 14.5189 2.88691 13.5488C3.39825 12.2097 2.76935 10.6914 1.46089 10.1061C0.513036 9.6821 0.513036 8.3179 1.46089 7.89389C2.76935 7.30858 3.39825 5.79028 2.88691 4.45118C2.51649 3.48113 3.48113 2.51649 4.45118 2.88691C5.79028 3.39825 7.30858 2.76934 7.89389 1.46089Z"
        stroke="#1A73E8" stroke-width="1.5" />
      <path
        d="M6.75128 12.05H7.637L10.987 6.75H10.1084L6.75128 12.05ZM6.787 9.71429C7.62271 9.71429 8.07985 9.17143 8.07985 8.23571C8.07985 7.31429 7.62271 6.77857 6.787 6.77857C5.95128 6.77857 5.49414 7.31429 5.49414 8.23571C5.49414 9.17143 5.95128 9.71429 6.787 9.71429ZM6.787 9.02857C6.46557 9.02857 6.29414 8.8 6.29414 8.24286C6.29414 7.7 6.46557 7.47143 6.787 7.47143C7.10128 7.47143 7.287 7.7 7.287 8.24286C7.287 8.8 7.10128 9.02857 6.787 9.02857ZM10.9584 12.0571C11.787 12.0571 12.2441 11.5143 12.2441 10.5857C12.2441 9.65714 11.787 9.12143 10.9584 9.12143C10.1156 9.12143 9.65843 9.65714 9.65843 10.5857C9.65843 11.5143 10.1156 12.0571 10.9584 12.0571ZM10.9584 11.3714C10.637 11.3714 10.4584 11.1429 10.4584 10.5929C10.4584 10.0357 10.637 9.80714 10.9584 9.80714C11.2727 9.80714 11.4513 10.0357 11.4513 10.5929C11.4513 11.1429 11.2727 11.3714 10.9584 11.3714Z"
        fill="#1A73E8" />
    </svg>
  </span>
</template>
  
<script type="text/ecmascript-6">

export default {
  name: 'StarIcon',

  props: {
    fillColor: {
      type: String,
      default: "none"
    },

    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
  